import Subscribable from 'common/provider/subscribable.provider';

export default class SessionService extends Subscribable() {
    /* @ngInject */
    constructor($q, apiService, storageService, appStartCacheService) {
        super();

        this.$q = $q;
        this.apiService = apiService;
        this.storageService = storageService;
        this.appStartCacheService = appStartCacheService;

        this.promise = null;
    }

    reload() {
        return this.initialize(true).catch((error) => {
            return this.$q.reject(error);
        });
    }

    initialize(reload) {
        if (!reload && this.promise) {
            return this.promise;
        }

        this.promise = this.apiService.onlyAuthorized()
            .then(() => {
                return this.apiService.get(`/context`)
                    .then((result) => {
                        return this.updateUser(result);
                    })
                    .catch((error) => {
                        this.clearUser();
                        return this.$q.reject(error);
                    });
            })
            .catch((error) => {
                this.clearUser();
                return this.$q.reject(error);
            });
        
        return this.promise;
    }

    updateUser(result) {
        if (result.data && result.data.user) {
            this.user = result.data.user;
            return result.data;
        }

        this.clearUser();
        return this.$q.reject(`We were unable to read and process your initial request. Please try again later.`);
    }

    deleteAccount() {
        return this.apiService.delete('/users/me')
            .finally(() => {
                this.changeTokenAndReload();
            });
    }

    clearUser() {
        this.user = null;
    }

    signIn(identity, password) {
        return this.apiService.post(`/sign-in`, {
            identity,
            password
        }, {
            anonymous: true
        })
            .then((result) => {
                return this.changeTokenAndReload(result)
                    .then((data) => {
                        if (!data || !data.user) {
                            return this.$q.reject(new Error('No user data after reload'));
                        }
                        return this.fire('sign-in', data.user);
                    });
            })
            .catch((error) => {
                return this.$q.reject(error || new Error('Sign in failed'));
            });
    }

    signUp(name, identity, password) {
        return this.apiService.post(`/sign-up`, {
            name,
            identity,
            password,
            email: identity
        }, {
            anonymous: true
        })
            .then(() => {
                return this.signIn(identity, password);
            })
            .catch((error) => {
                return this.$q.reject(error);
            });
    }

    signOut() {
        return this.apiService.post(`/sign-out`)
            .catch(() => this.$q.resolve())
            .finally(() => {
                // Clear the token and user data
                this.appStartCacheService.clearAll();
                this.apiService.token = null;
                this.storageService.setUserPrefix(null);
                this.clearUser();
                this.fire('change', null);
            });
    }

    refreshToken() {
        return this.apiService.post(`/refresh-token`, null, {
            anonymous: true
        }).then((result) => this.changeToken(result));
    }

    changeToken(result) {
        const token = result && result.data && result.data.token ? result.data.token : null;

        if (!token) {
            return this.$q.reject(new Error('No token received'));
        }

        this.apiService.token = token;
        this.fire('change', token);

        return this.$q.resolve(token);
    }

    changeTokenAndReload(result) {
        return this.changeToken(result)
            .then(() => {
                return this.apiService.onlyAuthorized()
                    .then(() => {
                        return this.reload();
                    });
            })
            .catch((error) => {
                return this.reload().then(() => this.$q.reject(error));
            });
    }

    onChange(callback) {
        return this.on('change', callback);
    }

    onSignIn(callback) {
        return this.on('sign-in', callback);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/session.service.js